import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import * as Sentry from '@sentry/react'
import './index.css'
import './i18n'
import App from './App.tsx'
import { initSentry } from './utils/sentry'
import { initializeIndexedDBErrorHandlers } from './utils/indexedDBErrorHandler'

// Initialize Sentry
initSentry()

// Initialize IndexedDB error handlers
initializeIndexedDBErrorHandlers()

// Create Sentry error boundary wrapper
const SentryErrorBoundary = Sentry.ErrorBoundary

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <SentryErrorBoundary fallback={<p>An error has occurred</p>}>
      <App />
    </SentryErrorBoundary>
  </StrictMode>,
)
